import React from "react";
import { Api } from "../../../api";
import { hasError } from "../../../helpers/ResponseHelper";
import MaterialTable from "material-table";
import { Chip } from "@material-ui/core";
import TableSearch from "../../Table/TableSearch";
import { useHistory } from "react-router-dom";
import Document from "../../../types/Document";
import MoreButton from "../../MoreButton";
import { CompanyContext } from "../../../context/CompanyContext";
import { useSnackbar } from "notistack";

interface IProps {
  groupId: string;
  type: string;
}
export default function AdminGroupDetailsDocuments(props: IProps) {
  const { groupId, type } = props;
  const [documents, setDocuments] = React.useState<Document[]>([]);
  const [loading, setLoading] = React.useState(false);
  const history = useHistory();
  const companyContext = React.useContext(CompanyContext);
  const { enqueueSnackbar } = useSnackbar();

  const loadDocuments = React.useCallback(() => {
    if (groupId && type) {
      setLoading(true);
      Api.documents
        .getForGroup(groupId)
        .then((res) => {
          if (!hasError(res)) {
            setDocuments(
              res?.data?.data?.filter((doc) => doc.documentType === type) ?? []
            );
          }
        })
        .finally(() => setLoading(false));
    }
  }, [groupId, type]);

  React.useEffect(() => {
    loadDocuments();
  }, [loadDocuments]);

  function getDocumentCategoriesString(document: Document) {
    let s: string = "";
    if (document.documentCategories) {
      for (let category of document.documentCategories) {
        if (s) {
          s += ", " + category.categoryName;
        } else {
          s = category.categoryName;
        }
      }
    }
    return s;
  }

  function moreHandler(menuItem: string, index: number, document: Document) {
    switch (menuItem) {
      case "Remove Document":
        deleteDocument(document.documentId);
        break;
    }
  }

  function deleteDocument(documentId: string) {
    setLoading(true);
    Api.assignment
      .deleteGroupDocuments(companyContext.companyId, groupId, [documentId])
      .then((res) => {
        if (!hasError(res)) {
          enqueueSnackbar("Documents removed successfully", {
            variant: "success",
          });
        }
      })
      .finally(() => {
        loadDocuments();
        setLoading(false);
      });
  }

  return (
    <div>
      <div className="datatable-container">
        <MaterialTable
          options={{
            selection: false,
            filtering: false,
            pageSize: 20,
          }}
          onRowClick={(event: any, rowData?: Document) => {
            if (rowData) history.push(`/document/${rowData.documentId}`);
          }}
          columns={[
            {
              title: "Active",
              field: "active",
              render: (rowData) =>
                rowData.active ? (
                  <Chip label="Active" color="primary" className="chip" />
                ) : (
                  <Chip label="Inactive" className="chip" />
                ),
            },
            { title: "TITLE", field: "documentName", defaultSort: "asc" },
            {
              title: "CATEGORY",
              field: "documentCategory",
              render: (rowData) => (
                <div style={{ fontSize: 12 }}>
                  {getDocumentCategoriesString(rowData)}
                </div>
              ),
              customSort: (a, b) =>
                a.documentCategories?.[0]?.categoryName
                  ?.toLocaleUpperCase()
                  .localeCompare(
                    b.documentCategories?.[0]?.categoryName?.toLocaleUpperCase()
                  ),
            },
            { title: "VERSION", field: "version" },
            {
              title: "",
              cellStyle: { textAlign: "right", width: "48px" },
              field: "active",
              render: (rowData) => (
                <MoreButton
                  rowData={rowData}
                  menuItems={["Remove Document"]}
                  menuItemSelectedHandler={moreHandler}
                />
              ),
            },
          ]}
          data={documents}
          components={{
            Toolbar: (props) => <TableSearch toolbarProps={props} />,
          }}
          isLoading={loading}
        />
      </div>
    </div>
  );
}
